import { SelectColumnFilter } from 'components/dataTables/FilterTypes/SelectColumnFilter';
import { RowEditAndDelete } from 'components/icons/RowEditAndDelete';

export const columnsDataProduct = [
	{
		Header: ' ',
		accessor: 'CheckBox',
		disableSortBy: true,
		type: 'checkBox',
		filter: false,
	},
	{
		Header: 'Nome do Produto',
		accessor: 'produto',
		type: 'text',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Cód. Produto',
		accessor: 'codigo_produto',
		type: 'text',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Custo',
		accessor: 'custo',
		type: 'money',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Família',
		accessor: 'familia',
		type: 'nullableTag',
		optional: true,
		createable: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Subfamília',
		accessor: 'subfamilia',
		type: 'nullableTag',
		dependsOnCreateable: true,
		dependesOn: 'familia',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Modelo',
		accessor: 'nomeModeloProduto',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Status',
		accessor: 'status',
		type: 'badge',
		badgeTrueText: 'Ativo',
		Filter: SelectColumnFilter,
		filter: 'equals',
	},
	{
		Header: 'Rateio',
		accessor: 'rateio',
		filter: false,
		type: 'switch-actionable',
	},
	{
		Header: 'Data Registro',
		accessor: 'dataRegistro',
		type: 'date',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: ' ',
		type: 'jsx',
		accessor: 'button',
		jsx: RowEditAndDelete,
		filter: false,
		module: 'produto',
	},
];
